import React from "react";
import CustomizedAvatar from "../../commons/CircularAvatar/CustomizedAvatar";
import {
  BlueFlagIcon,
  CalanderGrayIcon,
  GreenFlagIcon,
  GreyFlagIcon,
  RedFlagIcon,
} from "../../../assets/images";
import { SingleJobsScheduledHoursListType } from "../../../redux/scheduling/schedulingTypes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  data: any;
  singleJobScheduledHoursSum: number;
};
const JobSummaryDetails = ({ data, singleJobScheduledHoursSum }: AppProps) => {
  return (
    <>
      <div
        style={{
          border: "1px solid #bfcbe1",
          padding: "20px 30px 20px 27px",
          marginLeft: "25px",
          marginTop: "25px",
          width: "95%",
          borderRadius: "5px",
        }}
      >
        <div
          style={{ fontSize: "16px", fontWeight: "500", marginBottom: "13px" }}
        >
          {" "}
          Jobs Summary
        </div>

        <div
          className="mt-2"
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Job Type & ID
            </span>
            <div className="d-flex">
              <span>
                {data?.job_priority === "normal" ? (
                  <img src={GreyFlagIcon} />
                ) : data?.job_priority === "red" ? (
                  <img src={RedFlagIcon} />
                ) : data?.job_priority === "green" ? (
                  <img src={GreenFlagIcon} />
                ) : data?.job_priority === "blue" ? (
                  <img src={BlueFlagIcon} />
                ) : (
                  ""
                )}
              </span>
              <span
                style={{
                  color: "#262a44",
                  fontWeight: "normal",
                  fontSize: "14px",
                }}
              >
                {`${data?.job_id}_${
                  data?.job_type_details?.job_type
                    ? data?.job_type_details?.job_type
                    : ""
                }_${data?.period_ended}`}
              </span>
            </div>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Currently Responsible
            </span>
            <div
              className="d-flex"
              style={{ gap: "5px", alignItems: "center" }}
            >
              <div>
                {data?.currently_responsible?.first_name ? (
                  <CustomizedAvatar
                    name={`${
                      data?.currently_responsible?.first_name
                        ? data?.currently_responsible?.first_name
                        : ""
                    } ${
                      data?.currently_responsible?.last_name
                        ? data?.currently_responsible?.last_name
                        : ""
                    }`}
                    image={
                      data?.currently_responsible?.profile_pic?.file_url &&
                      data?.currently_responsible?.profile_pic?.file_url
                    }
                    style={{ width: "30px", fontSize: "10px" }}
                  />
                ) : (
                  ""
                )}
              </div>
              <div
                style={{
                  color: "#262a44",
                  fontWeight: "normal",
                  fontSize: "14px",
                }}
              >
                {`${
                  data?.currently_responsible?.first_name
                    ? data?.currently_responsible?.first_name
                    : ""
                } ${
                  data?.currently_responsible?.last_name
                    ? data?.currently_responsible?.last_name
                    : ""
                }`}
              </div>
            </div>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Details{" "}
            </span>

            <span
              style={{
                color: "#262a44",
                fontWeight: "normal",
                fontSize: "14px",
              }}
            >
              {/* {data?.job_description ? data?.job_description : "NA"}
               */}
                      {data?.job_description?.length>20 ? (
                  <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 250, hide: 250 }}
                  overlay={
                    <Tooltip id="button-view">
                      {data?.job_description}
                    </Tooltip>
                  }
                >
                  <span>
                    {data?.job_description.toLowerCase()?.substr(0, 20) +
                      (data?.job_description && data?.job_description?.length > 20
                        ? "..."
                        : "")}
                  </span>
                </OverlayTrigger>
                ): (data?.job_description?data?.job_description:"--/--")}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Start Date{" "}
            </span>
            <div className="d-flex">
              <span>
                <img src={CalanderGrayIcon} />
              </span>

              <span
                style={{
                  color: "#262a44",
                  fontWeight: "normal",
                  fontSize: "14px",
                }}
              >
                {data?.target_start_date ? data?.target_start_date : "NA"}
              </span>
            </div>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Target End Date{" "}
            </span>
            <div className="d-flex">
              <span>
                <img src={CalanderGrayIcon} />
              </span>
              <span
                style={{
                  color: "#262a44",
                  fontWeight: "normal",
                  fontSize: "14px",
                }}
              >
                {data?.target_end_date ? data?.target_end_date : "NA"}
              </span>
            </div>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Status{" "}
            </span>

            <span
              style={{
                color:  data?.job_status == "Open" ? "#82b01f" : "#6f7a90",
                backgroundColor: data?.job_status == "Open" ? "#e7f0d4" : "#f4f6f8",
                fontWeight: "normal",
                fontSize: "14px",
                borderRadius: "16px",
                padding: "2px 8px",
              }}
            >
              {data?.job_status ? data?.job_status : "NA"}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Total Hours Worked{" "}
            </span>

            <span
              style={{
                color: "#262a44",
                fontWeight: "normal",
                fontSize: "14px",
              }}
            >
              {singleJobScheduledHoursSum ? singleJobScheduledHoursSum : "NA"}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobSummaryDetails;
